export const CouriersAction = {
  SET_COURIERS: 'SET_COURIERS',
};
